const toggleStickyHeaderClasses = () => {
    try {
        let currentScrollPos = window.pageYOffset;
        if (prevScrollpos < currentScrollPos && currentScrollPos > 0) {
            document.getElementsByTagName('body')[0].classList.add('no-sticky-down');
        } else if (prevScrollpos > currentScrollPos || currentScrollPos <= 0) {
            document.getElementsByTagName('body')[0].classList.remove('no-sticky-down');
        }
        window.prevScrollpos = currentScrollPos;
    } catch (e) {
        console.error(e);
    }
}

const hideStickyHeaderOnScrollDown = () => {
    try {
        window.prevScrollpos = window.pageYOffset;
        window.addEventListener('scroll', toggleStickyHeaderClasses);
    } catch (error) {
        console.error(error);
    }
}

/**
 * This code will be trigger from an AB Test, if the client ever wants to push it live, uncomment the line below
 */
// To comment line after QA has passed
//hideStickyHeaderOnScrollDown();